export default "__VITE_PUBLIC_ASSET__a508f699__"